(function () {

    var formApp = angular.module('formApp');

    // this controller is use executes the functionality in introduction page
    formApp.controller('introductionController',
        ['$scope','$rootScope', '$location', '$timeout', 'UtilityServices', 'DataServices', 'Constants',
            function ($scope, $rootScope, $location, $timeout, UtilityServices, DataServices, Constants) {

        // this sets the page title
        document.title = 'Feedback Management System Introduction page';

        DataServices.incidentSubmitted = false;

                $scope.isLoading = false;
                if ($location.path().indexOf('DH') > -1) {
                    $scope.IsDHVisible = true;
                    //return true;
                }
                else {
                    $scope.IsDHVisible = false;
                }
                if ($location.path().indexOf('DFFH') > -1) {
                    $scope.IsDFFHVisible = true;
                    //return true;
                }
                else {
                    $scope.IsDFFHVisible = false;
                }
         

        // this gets and set the incident config data 
        var getConfigDataForIncidentAndRedirect = function () {
            $scope.isLoading = true;
            DataServices.getConfigurationUsingCache(Constants.ConfigTemplate.incident, null, null, DataServices.isAuthenticated())
                .then(function (data) {
                    $location.path(Constants.Url.firstIncidentFormPage);
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        }

        $scope.utility = UtilityServices;

        $scope.createIncident = function () {
            setDefaultValues();
            getConfigDataForIncidentAndRedirect();
            $rootScope.allowFormNavigation = true;
        };

        var setDefaultValues = function () {
            DataServices.responseInfo.responses = {};
            DataServices.responseInfo.lastUpdatedTime = null;
            DataServices.responseInfo.incidentId = null;
            DataServices.responseInfo.incidentRef = null;
            DataServices.responseInfo.reportedDate = null;
            DataServices.responseInfo.status = null;
            DataServices.responseInfo.submittedDate = null;
        }
    }]);
}());